(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5003],{

/***/ 26367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ie": function() { return /* binding */ Scrollspy; }
/* harmony export */ });
/* unused harmony exports Pagination, ReadingProgress, usePagination, useReadingProgress, useScrollspy */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var debounce = function debounce(callback) {
  var reqID = null;

  var exec = function exec(args) {
    return function () {
      // @ts-ignore TS2488
      callback.apply(void 0, args);
    };
  };

  return function () {
    if (reqID) {
      cancelAnimationFrame(reqID);
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    reqID = requestAnimationFrame(exec(args));
  };
};

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ReadingProgressCore = function ReadingProgressCore() {};

var ReadingProgressWindow = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_ReadingProgressCore) {
  _inheritsLoose(ReadingProgressWindow, _ReadingProgressCore);

  function ReadingProgressWindow() {
    var _this;

    _this = _ReadingProgressCore.apply(this, arguments) || this;

    _this.measureWrapperHeight = function () {
      var targetElHeihgt = document.body.getBoundingClientRect().height || 0;
      return Math.round(targetElHeihgt - _this.getViewportHeight());
    };

    _this.getViewportHeight = function () {
      return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    };

    _this.getProgress = function () {
      var top = window.pageYOffset || document.documentElement.scrollTop;
      return Math.round(top / _this.measureWrapperHeight() * 100);
    };

    return _this;
  }

  _createClass(ReadingProgressWindow, [{
    key: "rootSelector",
    get: function get() {
      return window;
    }
  }]);

  return ReadingProgressWindow;
}(ReadingProgressCore)));

var ReadingProgressElement = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_ReadingProgressCore2) {
  _inheritsLoose(ReadingProgressElement, _ReadingProgressCore2);

  function ReadingProgressElement(_ref) {
    var _this2;

    var rootEl = _ref.rootEl,
        targetEl = _ref.targetEl;
    _this2 = _ReadingProgressCore2.call(this) || this;

    _this2.measureWrapperHeight = function () {
      var _this2$targetEl;

      var targetElHeight = ((_this2$targetEl = _this2.targetEl) == null ? void 0 : _this2$targetEl.getBoundingClientRect().height) || 0;
      return Math.round(targetElHeight - _this2.getViewportHeight());
    };

    _this2.getViewportHeight = function () {
      var _this2$rootEl;

      return ((_this2$rootEl = _this2.rootEl) == null ? void 0 : _this2$rootEl.clientHeight) || 0;
    };

    _this2.getProgress = function () {
      var _this2$rootEl2;

      var top = ((_this2$rootEl2 = _this2.rootEl) == null ? void 0 : _this2$rootEl2.scrollTop) || 0;
      return Math.round(top / _this2.measureWrapperHeight() * 100);
    };

    _this2.rootEl = document.querySelector(rootEl);
    _this2.targetEl = document.querySelector(targetEl);
    return _this2;
  }

  _createClass(ReadingProgressElement, [{
    key: "rootSelector",
    get: function get() {
      return this.rootEl;
    }
  }]);

  return ReadingProgressElement;
}(ReadingProgressCore)));

var ReadingProgress = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function ReadingProgress(_ref2) {
    var _this3 = this;

    var rootEl = _ref2.rootEl,
        targetEl = _ref2.targetEl;

    this.getViewportHeight = function () {
      return _this3.rp.getViewportHeight();
    };

    this.getProgress = function () {
      return _this3.rp.getProgress();
    };

    this.rp = typeof rootEl === 'string' && typeof targetEl === 'string' ? new ReadingProgressElement({
      rootEl: rootEl,
      targetEl: targetEl
    }) : new ReadingProgressWindow();
  }

  _createClass(ReadingProgress, [{
    key: "rootSelector",
    get: function get() {
      return this.rp.rootSelector;
    }
  }]);

  return ReadingProgress;
}()));

var useReadingProgress = function useReadingProgress(props) {
  var _rp$current;

  var rp = useRef();
  useEffect(function () {
    rp.current = new ReadingProgress({
      rootEl: props == null ? void 0 : props.rootEl,
      targetEl: props == null ? void 0 : props.targetEl
    });
  }, [props]);

  var _useState = useState(((_rp$current = rp.current) == null ? void 0 : _rp$current.getProgress()) || 0),
      value = _useState[0],
      updateProgressValue = _useState[1];

  var update = useCallback(function () {
    var _rp$current2;

    updateProgressValue(((_rp$current2 = rp.current) == null ? void 0 : _rp$current2.getProgress()) || 0);
  }, []);
  var debounceUpdate = useCallback(debounce(function () {
    update();
  }), []);
  useEffect(function () {
    var _rp$current3;

    if ((_rp$current3 = rp.current) != null && _rp$current3.rootSelector) {
      rp.current.rootSelector.addEventListener('scroll', debounceUpdate);
    }

    window.addEventListener('resize', debounceUpdate);
    update();
    return function () {
      var _rp$current4;

      if ((_rp$current4 = rp.current) != null && _rp$current4.rootSelector) {
        rp.current.rootSelector.removeEventListener('scroll', debounceUpdate);
      }

      window.removeEventListener('resize', debounceUpdate);
    };
  }, [update, debounceUpdate]);
  return {
    value: value
  };
};

var ReadingProgress$1 = function ReadingProgress(_ref) {
  var targetEl = _ref.targetEl,
      rootEl = _ref.rootEl,
      children = _ref.children;
  var readingProgress = useReadingProgress({
    targetEl: targetEl,
    rootEl: rootEl
  });
  return children(readingProgress);
};

var Root = function Root() {};

var RootEl = /*#__PURE__*/function (_Root) {
  _inheritsLoose(RootEl, _Root);

  function RootEl(el) {
    var _this;

    _this = _Root.call(this) || this;
    _this.el = el;
    return _this;
  }

  var _proto = RootEl.prototype;

  _proto.isScrolledToBottom = function isScrolledToBottom() {
    return this.scrollTop + this.outerHeight >= this.scrollHeight;
  };

  _proto.registerScrollEvent = function registerScrollEvent(callback) {
    this.el.addEventListener('scroll', callback);
  };

  _proto.unregisterScrollEvent = function unregisterScrollEvent(callback) {
    this.el.removeEventListener('scroll', callback);
  };

  RootEl.create = function create(selector) {
    var el = document.querySelector(selector);

    if (!el) {
      throw new Error('element is not found.');
    }

    return new RootEl(el);
  };

  _createClass(RootEl, [{
    key: "top",
    get: function get() {
      return this.el.getBoundingClientRect().top;
    }
  }, {
    key: "outerHeight",
    get: function get() {
      return this.el.getBoundingClientRect().height;
    }
  }, {
    key: "scrollTop",
    get: function get() {
      return this.el.scrollTop;
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return this.el.scrollHeight;
    }
  }]);

  return RootEl;
}(Root);

var RootWindow = /*#__PURE__*/function (_Root) {
  _inheritsLoose(RootWindow, _Root);

  function RootWindow() {
    return _Root.apply(this, arguments) || this;
  }

  var _proto = RootWindow.prototype;

  _proto.isScrolledToBottom = function isScrolledToBottom() {
    return this.scrollTop + this.outerHeight >= this.scrollHeight;
  };

  _proto.registerScrollEvent = function registerScrollEvent(callback) {
    document.addEventListener('scroll', callback);
  };

  _proto.unregisterScrollEvent = function unregisterScrollEvent(callback) {
    document.removeEventListener('scroll', callback);
  };

  RootWindow.create = function create() {
    return new RootWindow();
  };

  _createClass(RootWindow, [{
    key: "outerHeight",
    get: function get() {
      return window.innerHeight;
    }
  }, {
    key: "scrollTop",
    get: function get() {
      return document.documentElement.scrollTop;
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return document.documentElement.scrollHeight;
    }
  }]);

  return RootWindow;
}(Root);

var RootFactory = /*#__PURE__*/function () {
  function RootFactory() {}

  RootFactory.create = function create(selector) {
    if (!selector) {
      return RootWindow.create();
    }

    return RootEl.create(selector);
  };

  return RootFactory;
}();

var useScrollspy = function useScrollspy(_ref) {
  var sectionRefs = _ref.sectionRefs,
      rootSelector = _ref.rootSelector,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset;
  var rootEl = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    rootEl.current = RootFactory.create(rootSelector);
  }, [rootSelector]);
  var isScrolledToBottom = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (!rootEl.current) {
      return false;
    }

    return rootEl.current.isScrolledToBottom();
  }, [rootEl]);
  var isElementInViewport = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (element) {
    if (!rootEl.current) {
      return false;
    }

    var innerScrollTop = rootEl.current.scrollTop;
    var innerScrollBottom = innerScrollTop + rootEl.current.outerHeight;
    var elementRect = element.getBoundingClientRect();
    var elementScrollTop = rootEl.current instanceof RootEl ? innerScrollTop + elementRect.top - rootEl.current.top + offset : innerScrollTop + elementRect.top + offset;
    var elementScrollBottom = elementScrollTop + elementRect.height;
    return [elementScrollTop < innerScrollBottom, elementScrollBottom > innerScrollTop].every(function (v) {
      return v;
    });
  }, [rootEl, offset]);
  var getElementsStatusInViewport = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return sectionRefs.map(function (sectionRef) {
      if (sectionRef.current) {
        return isElementInViewport(sectionRef.current);
      }

      return false;
    });
  }, [isElementInViewport, sectionRefs]);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      elementsStatusInViewport = _useState[0],
      updateElementsStatusInViewport = _useState[1];

  var currentElementIndexInViewport = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return elementsStatusInViewport.findIndex(function (status) {
      return status;
    });
  }, [elementsStatusInViewport]);
  var spy = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var newElementsStatusInViewport = isScrolledToBottom() ? [].concat(new Array(sectionRefs.length - 1).fill(false).map(function (v) {
      return v;
    }), [true]) : getElementsStatusInViewport();
    updateElementsStatusInViewport(newElementsStatusInViewport);
  }, [getElementsStatusInViewport, isScrolledToBottom, sectionRefs]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    spy();

    if (rootEl.current) {
      rootEl.current.registerScrollEvent(spy);
    }

    return function () {
      if (rootEl.current) {
        rootEl.current.unregisterScrollEvent(spy);
      }
    };
  }, [spy]);
  return {
    elementsStatusInViewport: elementsStatusInViewport,
    currentElementIndexInViewport: currentElementIndexInViewport
  };
};

var Scrollspy = function Scrollspy(_ref) {
  var children = _ref.children,
      sectionRefs = _ref.sectionRefs,
      rootSelector = _ref.rootSelector,
      offset = _ref.offset;

  var _useScrollspy = useScrollspy({
    sectionRefs: sectionRefs,
    rootSelector: rootSelector,
    offset: offset
  }),
      elementsStatusInViewport = _useScrollspy.elementsStatusInViewport,
      currentElementIndexInViewport = _useScrollspy.currentElementIndexInViewport;

  return children({
    elementsStatusInViewport: elementsStatusInViewport,
    currentElementIndexInViewport: currentElementIndexInViewport
  });
};

var Pagination = function Pagination(_ref) {
  var _this = this;

  var currentPage = _ref.currentPage,
      totalPage = _ref.totalPage,
      _ref$middlePagesSibli = _ref.middlePagesSiblingCount,
      middlePagesSiblingCount = _ref$middlePagesSibli === void 0 ? 2 : _ref$middlePagesSibli,
      _ref$edgePageCount = _ref.edgePageCount,
      edgePageCount = _ref$edgePageCount === void 0 ? 2 : _ref$edgePageCount;

  this.getAllPages = function () {
    return [].concat(Array(_this.totalPage)).fill(1).map(function (_, i) {
      return i + 1;
    });
  };

  this.getMiddlePageCount = function () {
    return _this.middlePagesSiblingCount * 2 + 1;
  };

  this.isReachedToFirst = function () {
    return _this.currentPage <= _this.middlePagesSiblingCount;
  };

  this.isReachedToLast = function () {
    return _this.currentPage + _this.middlePagesSiblingCount >= _this.totalPage;
  };

  this.getAllPreviousPages = function () {
    return _this.getAllPages().slice(0, _this.getMiddlePages()[0] - 1);
  };

  this.getAllNextPages = function () {
    var totalPageItems = _this.getAllPages();

    var middlePages = _this.getMiddlePages();

    return totalPageItems.slice(middlePages[middlePages.length - 1], totalPageItems[totalPageItems.length]);
  };

  this.hasPreviousPage = function () {
    return _this.currentPage > 1;
  };

  this.hasNextPage = function () {
    return _this.totalPage > _this.currentPage;
  };

  this.getMiddlePages = function () {
    var totalPageItems = _this.getAllPages();

    var middlePageCount = _this.getMiddlePageCount();

    if (_this.isReachedToFirst()) {
      return totalPageItems.slice(0, middlePageCount);
    }

    if (_this.isReachedToLast()) {
      return totalPageItems.slice(-middlePageCount);
    }

    return totalPageItems.slice(_this.currentPage - _this.middlePagesSiblingCount - 1, _this.currentPage + _this.middlePagesSiblingCount);
  };

  this.getPreviousPages = function () {
    if (_this.isReachedToFirst()) {
      return [];
    }

    if (_this.getAllPreviousPages().length < 1) {
      return [];
    }

    return _this.getAllPages().slice(0, _this.edgePageCount).filter(function (p) {
      return !_this.getMiddlePages().includes(p);
    });
  };

  this.getNextPages = function () {
    if (_this.isReachedToLast()) {
      return [];
    }

    if (_this.getAllNextPages().length < 1) {
      return [];
    }

    var totalPages = _this.getAllPages();

    return totalPages.slice(totalPages.length - _this.edgePageCount, totalPages.length).filter(function (p) {
      return !_this.getMiddlePages().includes(p);
    });
  };

  this.isPreviousTruncable = function () {
    return _this.getAllPreviousPages().filter(function (p) {
      return !_this.getPreviousPages().includes(p) && !_this.getMiddlePages().includes(p);
    }).length > 0;
  };

  this.isNextTruncable = function () {
    return _this.getAllNextPages().filter(function (p) {
      return !_this.getNextPages().includes(p) && !_this.getMiddlePages().includes(p);
    }).length > 0;
  };

  this.currentPage = currentPage;
  this.totalPage = totalPage;
  this.middlePagesSiblingCount = middlePagesSiblingCount;
  this.edgePageCount = edgePageCount;
};

var MIDDLE_PAGES_SIBLING_COUNT = 2;
var EDGE_PAGE_COUNT = 2;
var usePagination = function usePagination(_ref) {
  var totalPage = _ref.totalPage,
      currentPage = _ref.currentPage,
      _ref$middlePagesSibli = _ref.middlePagesSiblingCount,
      middlePagesSiblingCount = _ref$middlePagesSibli === void 0 ? MIDDLE_PAGES_SIBLING_COUNT : _ref$middlePagesSibli,
      _ref$edgePageCount = _ref.edgePageCount,
      edgePageCount = _ref$edgePageCount === void 0 ? EDGE_PAGE_COUNT : _ref$edgePageCount;
  var pagination = useMemo(function () {
    return new Pagination({
      totalPage: totalPage,
      currentPage: currentPage,
      middlePagesSiblingCount: middlePagesSiblingCount,
      edgePageCount: edgePageCount
    });
  }, [totalPage, currentPage, middlePagesSiblingCount, edgePageCount]);
  return {
    getMiddlePages: pagination.getMiddlePages,
    hasPreviousPage: pagination.hasPreviousPage,
    hasNextPage: pagination.hasNextPage,
    getPreviousPages: pagination.getPreviousPages,
    getNextPages: pagination.getNextPages,
    isPreviousTruncable: pagination.isPreviousTruncable,
    isNextTruncable: pagination.isNextTruncable,
    totalPage: totalPage,
    currentPage: currentPage
  };
};

var Pagination$1 = function Pagination(_ref) {
  var children = _ref.children,
      totalPage = _ref.totalPage,
      currentPage = _ref.currentPage,
      middlePagesSiblingCount = _ref.middlePagesSiblingCount,
      edgePageCount = _ref.edgePageCount;
  var pagination = usePagination({
    totalPage: totalPage,
    currentPage: currentPage,
    middlePagesSiblingCount: middlePagesSiblingCount,
    edgePageCount: edgePageCount
  });
  return children(pagination);
};


//# sourceMappingURL=ghostui.esm.js.map


/***/ }),

/***/ 75018:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/formacion-de-entrenadores-scrum",
      function () {
        return __webpack_require__(75701);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Check; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Check/Check.js



var defaultProps = {
    size: "w-6 h-6",
    className: null
};
var propTypes = {
    size: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Check(param) {
    var size = param.size, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: (0,clsx_m/* default */.Z)(size, className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
            clipRule: "evenodd"
        })
    });
};
Check.defaultProps = defaultProps;
Check.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Check/index.js

/* harmony default export */ var components_Check = (Check);


/***/ }),

/***/ 49187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoteImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);






var defaultProps = {
    className: null
};
var propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
var cloudinaryLoader = function(param) {
    var src = param.src;
    if (/^(f|ht)tps?:\/\//i.test(src)) {
        return src;
    }
    return "https://res.cloudinary.com/aibesorg/image/upload/f_auto,q_auto,fl_lossy,f_avif/".concat(src);
};
function RemoteImage(_param) {
    var src = _param.src, alt = _param.alt, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: src,
        alt: alt,
        loader: cloudinaryLoader,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("block h-auto max-w-full", className),
        placeholder: "blur",
        blurDataURL: "data:image/svg+xml;base64,"
    }, rest));
};
RemoteImage.defaultProps = defaultProps;
RemoteImage.propTypes = propTypes;


/***/ }),

/***/ 31233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Image/Picture.js


var defaultProps = {};
var propTypes = {
    children: (prop_types_default()).node.isRequired
};
function Picture(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        children: children
    });
};
Picture.defaultProps = defaultProps;
Picture.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/Image/Img.js



/* eslint-disable @next/next/no-img-element */ 


var Img_defaultProps = {
    fluid: true,
    title: null,
    className: null
};
var Img_propTypes = {
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string.isRequired,
    fluid: (prop_types_default()).bool,
    title: (prop_types_default()).string,
    className: (prop_types_default()).string
};
function Img(_param) {
    var src = _param.src, alt = _param.alt, fluid = _param.fluid, title = _param.title, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "fluid",
        "title",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt,
        title: title,
        className: (0,clsx_m/* default */.Z)(fluid && "h-auto max-w-full", className),
        loading: "lazy"
    }, rest));
}
Img.defaultProps = Img_defaultProps;
Img.propTypes = Img_propTypes;
var ImgForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
ImgForwardRef.displayName = "ImgForwardRef";
/* harmony default export */ var Image_Img = (ImgForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/isRemote.js
function isRemote(src) {
    return src.indexOf("//") !== -1;
};

;// CONCATENATED MODULE: ./src/components/Image/localImageSource.js
function localImageSource(src) {
    return "/images/".concat(src);
};

;// CONCATENATED MODULE: ./src/components/Image/Source.js


var Source_defaultProps = {
    sizes: null,
    srcset: null,
    media: "all"
};
var Source_propTypes = {
    sizes: (prop_types_default()).string,
    srcset: (prop_types_default()).string,
    type: (prop_types_default()).string.isRequired,
    media: prop_types_default().oneOfType([
        prop_types_default().oneOf([
            "all",
            "print",
            "screen",
            "speech"
        ]),
        (prop_types_default()).string, 
    ])
};
function Source(param) {
    var sizes = param.sizes, srcset = param.srcset, type = param.type, media = param.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        sizes: sizes,
        srcSet: srcset,
        type: type,
        media: media
    });
};
Source.defaultProps = Source_defaultProps;
Source.propTypes = Source_propTypes;

;// CONCATENATED MODULE: ./src/components/Image/renderSources.js


function renderSources(sources) {
    var keys = Object.keys(sources);
    if (keys === null || keys.length === 0) {
        return null;
    }
    return keys.map(function(type, index) {
        var src = sources[type];
        var srcSet = src;
        var sizes = null;
        if (Array.isArray(src) === true) {
            srcSet = src[0];
            sizes = src[1];
        }
        return renderSource(index, type, srcSet, sizes);
    });
};
function renderSource(index, type, srcSet) {
    var sizes = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Source, {
        type: type,
        srcSet: srcSet,
        sizes: sizes
    }, "source-".concat(index));
}

;// CONCATENATED MODULE: ./src/components/Image/Image.js










var Image_defaultProps = {
    fluid: false,
    sources: null,
    srcSet: null,
    sizes: null,
    className: ""
};
var Image_propTypes = {
    src: (prop_types_default()).string.isRequired,
    sources: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    srcSet: (prop_types_default()).string,
    sizes: (prop_types_default()).string,
    fluid: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
function Image(_param) {
    var src = _param.src, sources = _param.sources, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "sources"
    ]);
    var hasSources = sources && sources.length !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Picture, {
        children: [
            hasSources && renderSources(sources),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Img, (0,_object_spread/* default */.Z)({
                src: isRemote(src) ? src : localImageSource(src)
            }, rest))
        ]
    });
}
Image.defaultProps = Image_defaultProps;
Image.propTypes = Image_propTypes;
var ImageForwardRef = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var alt = _param.alt, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt"
    ]);
    return (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
        ref: ref,
        alt: alt
    }, props));
});
ImageForwardRef.displayName = "ImageForwardRef";
/* harmony default export */ var Image_Image = (ImageForwardRef);

;// CONCATENATED MODULE: ./src/components/Image/index.js

/* harmony default export */ var components_Image = (Image_Image);


/***/ }),

/***/ 82639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ ScrollSpyItem; },
  "Z": function() { return /* binding */ ScrollSpy; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@makotot/ghostui/dist/ghostui.esm.js
var ghostui_esm = __webpack_require__(26367);
;// CONCATENATED MODULE: ./src/components/ScrollSpy/ScrollSpy.js






var defaultProps = {
    className: null
};
var propTypes = {
    className: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
function ScrollSpyComponent(_param) {
    var className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ghostui_esm/* Scrollspy */.ie, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, props), {
        children: children
    }));
};
ScrollSpyComponent.defaultProps = defaultProps;
ScrollSpyComponent.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/ScrollSpy/ScrollSpyItem.js






var ScrollSpyItem_defaultProps = {
    className: null,
    targetClassName: null
};
var ScrollSpyItem_propTypes = {
    anchor: (prop_types_default()).string.isRequired,
    label: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string,
    targetClassName: (prop_types_default()).string
};
function ScrollSpyItem(_param) {
    var anchor = _param.anchor, label = _param.label, className = _param.className, targetClassName = _param.targetClassName, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "anchor",
        "label",
        "className",
        "targetClassName"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: "#".concat(anchor),
            className: (0,clsx_m/* default */.Z)("whitespace-nowrap text-base lg:text-lg", targetClassName, className)
        }, rest), {
            children: label
        }))
    });
};
ScrollSpyItem.defaultProps = ScrollSpyItem_defaultProps;
ScrollSpyItem.propTypes = ScrollSpyItem_propTypes;

;// CONCATENATED MODULE: ./src/components/ScrollSpy/index.js


/* harmony default export */ var ScrollSpy = (ScrollSpyComponent);



/***/ }),

/***/ 77276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SubHeading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/DynamicPropsInjection/index.js + 3 modules
var DynamicPropsInjection = __webpack_require__(2183);
// EXTERNAL MODULE: ./src/shapes/index.js + 16 modules
var shapes = __webpack_require__(71634);
;// CONCATENATED MODULE: ./src/components/Spacing/Spacing.js







var defaultProps = {
    horizontal: null,
    vertical: null,
    top: null,
    bottom: null,
    left: null,
    right: null,
    type: "m",
    inject: false,
    className: "",
    children: null
};
var propTypes = {
    horizontal: shapes/* ShapeSpacing */.N0,
    vertical: shapes/* ShapeSpacing */.N0,
    top: shapes/* ShapeSpacing */.N0,
    bottom: shapes/* ShapeSpacing */.N0,
    left: shapes/* ShapeSpacing */.N0,
    right: shapes/* ShapeSpacing */.N0,
    type: prop_types_default().oneOf([
        "m",
        "p"
    ]),
    inject: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Spacing(_param) {
    var horizontal = _param.horizontal, vertical = _param.vertical, top = _param.top, bottom = _param.bottom, left = _param.left, right = _param.right, type = _param.type, inject = _param.inject, className = _param.className, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "horizontal",
        "vertical",
        "top",
        "bottom",
        "left",
        "right",
        "type",
        "inject",
        "className",
        "children"
    ]);
    var classes = [
        className
    ];
    if (horizontal || left === right && left !== null) {
        classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
            "".concat(type, "x-").concat(horizontal || left)
        ]);
    } else {
        if (left !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "l-").concat(left)
            ]);
        }
        if (right !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "r-").concat(right)
            ]);
        }
    }
    if (vertical || top === bottom && top !== null) {
        classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
            "".concat(type, "y-").concat(vertical || top)
        ]);
    } else {
        if (top !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "t-").concat(top)
            ]);
        }
        if (bottom !== null) {
            classes = (0,_to_consumable_array/* default */.Z)(classes).concat([
                "".concat(type, "b-").concat(bottom)
            ]);
        }
    }
    var content;
    if (!inject) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: children
        });
    } else {
        content = children;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPropsInjection/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(classes),
        props: rest,
        children: content
    });
};
Spacing.defaultProps = defaultProps;
Spacing.propTypes = propTypes;


;// CONCATENATED MODULE: ./src/components/Spacing/index.js

/* harmony default export */ var components_Spacing = (Spacing);


// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/Text/index.js + 1 modules
var Text = __webpack_require__(37346);
;// CONCATENATED MODULE: ./src/components/SubHeading/SubHeading.js






var SubHeading_defaultProps = {
    color: "text-green-500"
};
var SubHeading_propTypes = {
    heading: (prop_types_default()).string.isRequired,
    color: (prop_types_default()).string
};
function SubHeading(param) {
    var heading = param.heading, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Spacing, {
        bottom: 4,
        inject: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            padding: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: (0,clsx_m/* default */.Z)("inline-flex text-xl font-semibold leading-none tracking-tight", color),
                children: heading
            })
        })
    });
};
SubHeading.defaultProps = SubHeading_defaultProps;
SubHeading.propTypes = SubHeading_propTypes;

;// CONCATENATED MODULE: ./src/components/SubHeading/index.js

/* harmony default export */ var components_SubHeading = (SubHeading);


/***/ }),

/***/ 37346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Text; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
;// CONCATENATED MODULE: ./src/components/Text/Text.js




var defaultProps = {
    muted: false,
    xsmall: false,
    small: false,
    large: false,
    medium: false,
    semibold: false,
    className: "",
    children: ""
};
var propTypes = {
    muted: (prop_types_default()).bool,
    xsmall: (prop_types_default()).bool,
    small: (prop_types_default()).bool,
    large: (prop_types_default()).bool,
    medium: (prop_types_default()).bool,
    semibold: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Text(param) {
    var muted = param.muted, xsmall = param.xsmall, small = param.small, large = param.large, medium = param.medium, semibold = param.semibold, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: (0,clsx_m/* default */.Z)(className, {
            "text-gray-500": muted,
            "text-xs": xsmall,
            "text-sm": small,
            "text-lg": large,
            "font-medium": medium,
            "font-semibold": semibold
        }),
        children: children
    });
};
Text.defaultProps = defaultProps;
Text.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Text/index.js

/* harmony default export */ var components_Text = (Text);


/***/ }),

/***/ 20890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ countriesOptions; },
  "n": function() { return /* binding */ countryCodes; }
});

;// CONCATENATED MODULE: ./src/api/countries.json
var countries_namespaceObject = JSON.parse('[{"name_en":"Afghanistan","name_es":"Afganistán","dial_code":"+93","code":"AF"},{"name_en":"Albania","name_es":"Albania","dial_code":"+355","code":"AL"},{"name_en":"Algeria","name_es":"Argelia","dial_code":"+213","code":"DZ"},{"name_en":"AmericanSamoa","name_es":"Samoa Americana","dial_code":"+1684","code":"AS"},{"name_en":"Andorra","name_es":"Andorra","dial_code":"+376","code":"AD"},{"name_en":"Angola","name_es":"Angola","dial_code":"+244","code":"AO"},{"name_en":"Anguilla","name_es":"Anguilla","dial_code":"+1264","code":"AI"},{"name_en":"Antarctica","name_es":"Antártida","dial_code":"+672","code":"AQ"},{"name_en":"Antigua and Barbuda","name_es":"Antigua y Barbuda","dial_code":"+1268","code":"AG"},{"name_en":"Argentina","name_es":"Argentina","dial_code":"+54","code":"AR"},{"name_en":"Armenia","name_es":"Armenia","dial_code":"+374","code":"AM"},{"name_en":"Aruba","name_es":"Aruba","dial_code":"+297","code":"AW"},{"name_en":"Australia","name_es":"Australia","dial_code":"+61","code":"AU"},{"name_en":"Austria","name_es":"Austria","dial_code":"+43","code":"AT"},{"name_en":"Azerbaijan","name_es":"Azerbaiyán","dial_code":"+994","code":"AZ"},{"name_en":"Bahamas","name_es":"Bahamas","dial_code":"+1242","code":"BS"},{"name_en":"Bahrain","name_es":"Baréin","dial_code":"+973","code":"BH"},{"name_en":"Bangladesh","name_es":"Banglades","dial_code":"+880","code":"BD"},{"name_en":"Barbados","name_es":"Barbados","dial_code":"+1246","code":"BB"},{"name_en":"Belarus","name_es":"Bielorrusia","dial_code":"+375","code":"BY"},{"name_en":"Belgium","name_es":"Bélgica","dial_code":"+32","code":"BE"},{"name_en":"Belize","name_es":"Belice","dial_code":"+501","code":"BZ"},{"name_en":"Benin","name_es":"Benin","dial_code":"+229","code":"BJ"},{"name_en":"Bermuda","name_es":"Bermudas","dial_code":"+1441","code":"BM"},{"name_en":"Bhutan","name_es":"Butan","dial_code":"+975","code":"BT"},{"name_en":"Bolivia","name_es":"Bolivia","dial_code":"+591","code":"BO"},{"name_en":"Bosnia and Herzegovina","name_es":"Bosnia-Herzegovina","dial_code":"+387","code":"BA"},{"name_en":"Botswana","name_es":"Botsuana","dial_code":"+267","code":"BW"},{"name_en":"Brazil","name_es":"Brasil","dial_code":"+55","code":"BR"},{"name_en":"British Indian Ocean Territory","name_es":"Territorio Británico del Océano Índico","dial_code":"+246","code":"IO"},{"name_en":"Brunei Darussalam","name_es":"Brunei","dial_code":"+673","code":"BN"},{"name_en":"Bulgaria","name_es":"Bulgaria","dial_code":"+359","code":"BG"},{"name_en":"Burkina Faso","name_es":"Burkina Faso","dial_code":"+226","code":"BF"},{"name_en":"Burundi","name_es":"Burundi","dial_code":"+257","code":"BI"},{"name_en":"Cambodia","name_es":"Camboya","dial_code":"+855","code":"KH"},{"name_en":"Cameroon","name_es":"Camerún","dial_code":"+237","code":"CM"},{"name_en":"Canada","name_es":"Canadá","dial_code":"+1","code":"CA"},{"name_en":"Cape Verde","name_es":"Cabo Verde","dial_code":"+238","code":"CV"},{"name_en":"Cayman Islands","name_es":"Islas Caimán","dial_code":"+ 345","code":"KY"},{"name_en":"Central African Republic","name_es":"República Centroafricana","dial_code":"+236","code":"CF"},{"name_en":"Chad","name_es":"Chad","dial_code":"+235","code":"TD"},{"name_en":"Chile","name_es":"Chile","dial_code":"+56","code":"CL"},{"name_en":"China","name_es":"China","dial_code":"+86","code":"CN"},{"name_en":"Christmas Island","name_es":"Isla de Navidad","dial_code":"+61","code":"CX"},{"name_en":"Cocos (Keeling) Islands","name_es":"Islas Cocos","dial_code":"+61","code":"CC"},{"name_en":"Colombia","name_es":"Colombia","dial_code":"+57","code":"CO"},{"name_en":"Comoros","name_es":"Comoras","dial_code":"+269","code":"KM"},{"name_en":"Congo","name_es":"Congo","dial_code":"+242","code":"CG"},{"name_en":"Congo, The Democratic Republic of the","name_es":"República Democrática del Congo","dial_code":"+243","code":"CD"},{"name_en":"Cook Islands","name_es":"Islas Cook","dial_code":"+682","code":"CK"},{"name_en":"Costa Rica","name_es":"Costa Rica","dial_code":"+506","code":"CR"},{"name_en":"Cote d\'Ivoire","name_es":"Costa de Marfil","dial_code":"+225","code":"CI"},{"name_en":"Croatia","name_es":"Croacia","dial_code":"+385","code":"HR"},{"name_en":"Cuba","name_es":"Cuba","dial_code":"+53","code":"CU"},{"name_en":"Cyprus","name_es":"Chipre","dial_code":"+537","code":"CY"},{"name_en":"Czechia","name_es":"Chequia","dial_code":"+420","code":"CZ"},{"name_en":"Denmark","name_es":"Dinamarca","dial_code":"+45","code":"DK"},{"name_en":"Djibouti","name_es":"Yibuti","dial_code":"+253","code":"DJ"},{"name_en":"Dominica","name_es":"Dominica","dial_code":"+1767","code":"DM"},{"name_en":"Dominican Republic","name_es":"República Dominicana","dial_code":"+1849","code":"DO"},{"name_en":"Ecuador","name_es":"Ecuador","dial_code":"+593","code":"EC"},{"name_en":"Egypt","name_es":"Egipto","dial_code":"+20","code":"EG"},{"name_en":"El Salvador","name_es":"El Salvador","dial_code":"+503","code":"SV"},{"name_en":"Equatorial Guinea","name_es":"Guinea Ecuatorial","dial_code":"+240","code":"GQ"},{"name_en":"Eritrea","name_es":"Eritrea","dial_code":"+291","code":"ER"},{"name_en":"Estonia","name_es":"Estonia","dial_code":"+372","code":"EE"},{"name_en":"Ethiopia","name_es":"Etiopía","dial_code":"+251","code":"ET"},{"name_en":"Falkland Islands (Malvinas)","name_es":"Islas Malvinas","dial_code":"+500","code":"FK"},{"name_en":"Faroe Islands","name_es":"Islas Feroe","dial_code":"+298","code":"FO"},{"name_en":"Fiji","name_es":"Fiyi","dial_code":"+679","code":"FJ"},{"name_en":"Finland","name_es":"Finlandia","dial_code":"+358","code":"FI"},{"name_en":"France","name_es":"Francia","dial_code":"+33","code":"FR"},{"name_en":"French Guiana","name_es":"Guayana Francesa","dial_code":"+594","code":"GF"},{"name_en":"French Polynesia","name_es":"Polinesia Francesa","dial_code":"+689","code":"PF"},{"name_en":"Gabon","name_es":"Gabón","dial_code":"+241","code":"GA"},{"name_en":"Gambia","name_es":"Gambia","dial_code":"+220","code":"GM"},{"name_en":"Georgia","name_es":"Georgia","dial_code":"+995","code":"GE"},{"name_en":"Germany","name_es":"Alemania","dial_code":"+49","code":"DE"},{"name_en":"Ghana","name_es":"Ghana","dial_code":"+233","code":"GH"},{"name_en":"Gibraltar","name_es":"Gibraltar","dial_code":"+350","code":"GI"},{"name_en":"Greece","name_es":"Grecia","dial_code":"+30","code":"GR"},{"name_en":"Greenland","name_es":"Groenlandia","dial_code":"+299","code":"GL"},{"name_en":"Grenada","name_es":"Granada","dial_code":"+1473","code":"GD"},{"name_en":"Guadeloupe","name_es":"Guadalupe","dial_code":"+590","code":"GP"},{"name_en":"Guam","name_es":"Guam","dial_code":"+1671","code":"GU"},{"name_en":"Guatemala","name_es":"Guatemala","dial_code":"+502","code":"GT"},{"name_en":"Guernsey","name_es":"Guernsey","dial_code":"+44","code":"GG"},{"name_en":"Guinea","name_es":"Guinea","dial_code":"+224","code":"GN"},{"name_en":"Guinea-Bissau","name_es":"Guinea-Bisau","dial_code":"+245","code":"GW"},{"name_en":"Guyana","name_es":"Guyana","dial_code":"+595","code":"GY"},{"name_en":"Haiti","name_es":"Haití","dial_code":"+509","code":"HT"},{"name_en":"Holy See (Vatican City State)","name_es":"Ciudad del Vaticano","dial_code":"+379","code":"VA"},{"name_en":"Honduras","name_es":"Honduras","dial_code":"+504","code":"HN"},{"name_en":"Hong Kong","name_es":"Hong Kong","dial_code":"+852","code":"HK"},{"name_en":"Hungary","name_es":"Hungría","dial_code":"+36","code":"HU"},{"name_en":"Iceland","name_es":"Islandia","dial_code":"+354","code":"IS"},{"name_en":"India","name_es":"India","dial_code":"+91","code":"IN"},{"name_en":"Indonesia","name_es":"Indonesia","dial_code":"+62","code":"ID"},{"name_en":"Iran, Islamic Republic of","name_es":"Irán","dial_code":"+98","code":"IR"},{"name_en":"Iraq","name_es":"Iraq","dial_code":"+964","code":"IQ"},{"name_en":"Ireland","name_es":"Irlanda","dial_code":"+353","code":"IE"},{"name_en":"Isle of Man","name_es":"Isla de Man","dial_code":"+44","code":"IM"},{"name_en":"Israel","name_es":"Israel","dial_code":"+972","code":"IL"},{"name_en":"Italy","name_es":"Italia","dial_code":"+39","code":"IT"},{"name_en":"Jamaica","name_es":"Jamaica","dial_code":"+1876","code":"JM"},{"name_en":"Japan","name_es":"Japón","dial_code":"+81","code":"JP"},{"name_en":"Jersey","name_es":"Jersey","dial_code":"+44","code":"JE"},{"name_en":"Jordan","name_es":"Jordania","dial_code":"+962","code":"JO"},{"name_en":"Kazakhstan","name_es":"Kazajistán","dial_code":"+7","code":"KZ"},{"name_en":"Kenya","name_es":"Kenia","dial_code":"+254","code":"KE"},{"name_en":"Kiribati","name_es":"Kiribati","dial_code":"+686","code":"KI"},{"name_en":"Korea, Democratic People\'s Republic of","name_es":"Corea del Norte","dial_code":"+850","code":"KP"},{"name_en":"Korea, Republic of","name_es":"Corea del Sur","dial_code":"+82","code":"KR"},{"name_en":"Kosovo","name_es":"Kosovo","dial_code":"+383","code":"XK"},{"name_en":"Kuwait","name_es":"Kuwait","dial_code":"+965","code":"KW"},{"name_en":"Kyrgyzstan","name_es":"Kirguistán","dial_code":"+996","code":"KG"},{"name_en":"Lao People\'s Democratic Republic","name_es":"Laos","dial_code":"+856","code":"LA"},{"name_en":"Latvia","name_es":"Letonia","dial_code":"+371","code":"LV"},{"name_en":"Lebanon","name_es":"Líbano","dial_code":"+961","code":"LB"},{"name_en":"Lesotho","name_es":"Lesoto","dial_code":"+266","code":"LS"},{"name_en":"Liberia","name_es":"Liberia","dial_code":"+231","code":"LR"},{"name_en":"Libyan Arab Jamahiriya","name_es":"Libia","dial_code":"+218","code":"LY"},{"name_en":"Liechtenstein","name_es":"Liechtenstein","dial_code":"+423","code":"LI"},{"name_en":"Lithuania","name_es":"Lituania","dial_code":"+370","code":"LT"},{"name_en":"Luxembourg","name_es":"Luxemburgo","dial_code":"+352","code":"LU"},{"name_en":"Macao","name_es":"Macao","dial_code":"+853","code":"MO"},{"name_en":"Macedonia, The Former Yugoslav Republic of","name_es":"República de Macedonia","dial_code":"+389","code":"MK"},{"name_en":"Madagascar","name_es":"Madagascar","dial_code":"+261","code":"MG"},{"name_en":"Malawi","name_es":"Malaui","dial_code":"+265","code":"MW"},{"name_en":"Malaysia","name_es":"Malasia","dial_code":"+60","code":"MY"},{"name_en":"Maldives","name_es":"Maldivas","dial_code":"+960","code":"MV"},{"name_en":"Mali","name_es":"Malí","dial_code":"+223","code":"ML"},{"name_en":"Malta","name_es":"Malta","dial_code":"+356","code":"MT"},{"name_en":"Marshall Islands","name_es":"Islas Marshall","dial_code":"+692","code":"MH"},{"name_en":"Martinique","name_es":"Martinica","dial_code":"+596","code":"MQ"},{"name_en":"Mauritania","name_es":"Mauritania","dial_code":"+222","code":"MR"},{"name_en":"Mauritius","name_es":"Mauricio","dial_code":"+230","code":"MU"},{"name_en":"Mayotte","name_es":"Mayotte","dial_code":"+262","code":"YT"},{"name_en":"Mexico","name_es":"México","dial_code":"+52","code":"MX"},{"name_en":"Micronesia, Federated States of","name_es":"Estados Federados de Micronesia","dial_code":"+691","code":"FM"},{"name_en":"Moldova, Republic of","name_es":"Moldavia","dial_code":"+373","code":"MD"},{"name_en":"Monaco","name_es":"Monaco","dial_code":"+377","code":"MC"},{"name_en":"Mongolia","name_es":"Mongolia","dial_code":"+976","code":"MN"},{"name_en":"Montenegro","name_es":"Montenegro","dial_code":"+382","code":"ME"},{"name_en":"Montserrat","name_es":"Montserrat","dial_code":"+1664","code":"MS"},{"name_en":"Morocco","name_es":"Marruecos","dial_code":"+212","code":"MA"},{"name_en":"Mozambique","name_es":"Mozambique","dial_code":"+258","code":"MZ"},{"name_en":"Myanmar","name_es":"Birmania","dial_code":"+95","code":"MM"},{"name_en":"Namibia","name_es":"Namibia","dial_code":"+264","code":"NA"},{"name_en":"Nauru","name_es":"Nauru","dial_code":"+674","code":"NR"},{"name_en":"Nepal","name_es":"Nepal","dial_code":"+977","code":"NP"},{"name_en":"Netherlands","name_es":"Holanda","dial_code":"+31","code":"NL"},{"name_en":"Netherlands Antilles","name_es":"Antillas Holandesas","dial_code":"+599","code":"AN"},{"name_en":"New Caledonia","name_es":"Nueva Caledonia","dial_code":"+687","code":"NC"},{"name_en":"New Zealand","name_es":"Nueva Zelanda","dial_code":"+64","code":"NZ"},{"name_en":"Nicaragua","name_es":"Nicaragua","dial_code":"+505","code":"NI"},{"name_en":"Niger","name_es":"Niger","dial_code":"+227","code":"NE"},{"name_en":"Nigeria","name_es":"Nigeria","dial_code":"+234","code":"NG"},{"name_en":"Niue","name_es":"Niue","dial_code":"+683","code":"NU"},{"name_en":"NorfolkIsland","name_es":"IslaNorfolk","dial_code":"+672","code":"NF"},{"name_en":"NorthernMarianaIslands","name_es":"IslasMarianasdelNorte","dial_code":"+1670","code":"MP"},{"name_en":"Norway","name_es":"Noruega","dial_code":"+47","code":"NO"},{"name_en":"Oman","name_es":"Omán","dial_code":"+968","code":"OM"},{"name_en":"Pakistan","name_es":"Pakistán","dial_code":"+92","code":"PK"},{"name_en":"Palau","name_es":"Palaos","dial_code":"+680","code":"PW"},{"name_en":"Panama","name_es":"Panamá","dial_code":"+507","code":"PA"},{"name_en":"Papua New Guinea","name_es":"Papúa Nueva Guinea","dial_code":"+675","code":"PG"},{"name_en":"Paraguay","name_es":"Paraguay","dial_code":"+595","code":"PY"},{"name_en":"Peru","name_es":"Perú","dial_code":"+51","code":"PE"},{"name_en":"Philippines","name_es":"Filipinas","dial_code":"+63","code":"PH"},{"name_en":"Pitcairn","name_es":"Islas Pitcairn","dial_code":"+872","code":"PN"},{"name_en":"Poland","name_es":"Polonia","dial_code":"+48","code":"PL"},{"name_en":"Portugal","name_es":"Portugal","dial_code":"+351","code":"PT"},{"name_en":"Puerto Rico","name_es":"Puerto Rico","dial_code":"+1939","code":"PR"},{"name_en":"Qatar","name_es":"Qatar","dial_code":"+974","code":"QA"},{"name_en":"Romania","name_es":"Rumania","dial_code":"+40","code":"RO"},{"name_en":"Russia","name_es":"Rusia","dial_code":"+7","code":"RU"},{"name_en":"Rwanda","name_es":"Ruanda","dial_code":"+250","code":"RW"},{"name_en":"Réunion","name_es":"Reunion","dial_code":"+262","code":"RE"},{"name_en":"Saint Barthélemy","name_es":"San Bartolome","dial_code":"+590","code":"BL"},{"name_en":"Saint Helena, Ascension and Tristan Da Cunha","name_es":"Santa Elena, Ascensión y Tristán de Acuña","dial_code":"+290","code":"SH"},{"name_en":"Saint Kitts and Nevis","name_es":"San Cristóbal y Nieves","dial_code":"+1869","code":"KN"},{"name_en":"Saint Lucia","name_es":"Santa Lucía","dial_code":"+1758","code":"LC"},{"name_en":"Saint Martin","name_es":"Isla de San Martín","dial_code":"+590","code":"MF"},{"name_en":"Saint Pierre and Miquelon","name_es":"San Pedro y Miquelon","dial_code":"+508","code":"PM"},{"name_en":"Saint Vincent and the Grenadines","name_es":"San Vicente y las Granadinas","dial_code":"+1784","code":"VC"},{"name_en":"Samoa","name_es":"Samoa","dial_code":"+685","code":"WS"},{"name_en":"San Marino","name_es":"San Marino","dial_code":"+378","code":"SM"},{"name_en":"Sao Tome and Principe","name_es":" Santo Tomé y Príncipe","dial_code":"+239","code":"ST"},{"name_en":"Saudi Arabia","name_es":"Arabia Saudita","dial_code":"+966","code":"SA"},{"name_en":"Senegal","name_es":"Senegal","dial_code":"+221","code":"SN"},{"name_en":"Serbia","name_es":"Serbia","dial_code":"+381","code":"RS"},{"name_en":"Seychelles","name_es":"Seychelles","dial_code":"+248","code":"SC"},{"name_en":"Sierra Leone","name_es":"Sierra Leona","dial_code":"+232","code":"SL"},{"name_en":"Singapore","name_es":"Singapur","dial_code":"+65","code":"SG"},{"name_en":"Slovakia","name_es":"Eslovaquia","dial_code":"+421","code":"SK"},{"name_en":"Slovenia","name_es":"Eslovenia","dial_code":"+386","code":"SI"},{"name_en":"Solomon Islands","name_es":"Islas Salomón","dial_code":"+677","code":"SB"},{"name_en":"Somalia","name_es":"Somalia","dial_code":"+252","code":"SO"},{"name_en":"South Africa","name_es":"Sudáfrica","dial_code":"+27","code":"ZA"},{"name_en":"South Sudan","name_es":"Sudán del Sur","dial_code":"+211","code":"SS"},{"name_en":"Spain","name_es":"España","dial_code":"+34","code":"ES"},{"name_en":"Sri Lanka","name_es":"Sri Lanka","dial_code":"+94","code":"LK"},{"name_en":"State of Palestine","name_es":"Estado de Palestina","dial_code":"+970","code":"PS"},{"name_en":"Sudan","name_es":"Sudán","dial_code":"+249","code":"SD"},{"name_en":"Suriname","name_es":"Surinam","dial_code":"+597","code":"SR"},{"name_en":"Svalbard and Jan Mayen","name_es":"Svalbard y Jan Mayen","dial_code":"+47","code":"SJ"},{"name_en":"Swaziland","name_es":"Suazilandia","dial_code":"+268","code":"SZ"},{"name_en":"Sweden","name_es":"Suecia","dial_code":"+46","code":"SE"},{"name_en":"Switzerland","name_es":"Suiza","dial_code":"+41","code":"CH"},{"name_en":"Syrian Arab Republic","name_es":"Siria","dial_code":"+963","code":"SY"},{"name_en":"Taiwan, Province of China","name_es":"Taiwán","dial_code":"+886","code":"TW"},{"name_en":"Tayikistan","name_es":"Tayikistán","dial_code":"+992","code":"TJ"},{"name_en":"Tanzania, United Republic of","name_es":"Tanzania","dial_code":"+255","code":"TZ"},{"name_en":"Thailand","name_es":"Tailandia","dial_code":"+66","code":"TH"},{"name_en":"Timor-Leste","name_es":"Timor Oriental","dial_code":"+670","code":"TL"},{"name_en":"Togo","name_es":"Togo","dial_code":"+228","code":"TG"},{"name_en":"Tokelau","name_es":"Tokelau","dial_code":"+690","code":"TK"},{"name_en":"Tonga","name_es":"Tonga","dial_code":"+676","code":"TO"},{"name_en":"Trinidad and Tobago","name_es":"Trinidad y Tobago","dial_code":"+1868","code":"TT"},{"name_en":"Tunisia","name_es":"Túnez","dial_code":"+216","code":"TN"},{"name_en":"Turkey","name_es":"Turquía","dial_code":"+90","code":"TR"},{"name_en":"Turkmenistan","name_es":"Turkmenistán","dial_code":"+993","code":"TM"},{"name_en":"Turks and Caicos Islands","name_es":"Islas Turcas y Caicos","dial_code":"+1649","code":"TC"},{"name_en":"Tuvalu","name_es":"Tuvalu","dial_code":"+688","code":"TV"},{"name_en":"Uganda","name_es":"Uganda","dial_code":"+256","code":"UG"},{"name_en":"Ukraine","name_es":"Ucrania","dial_code":"+380","code":"UA"},{"name_en":"United Arab Emirates","name_es":"Emiratos Árabes Unidos","dial_code":"+971","code":"AE"},{"name_en":"United Kingdom","name_es":"Reino Unido","dial_code":"+44","code":"GB"},{"name_en":"United States","name_es":"Estados Unidos","dial_code":"+1","code":"US"},{"name_en":"Uruguay","name_es":"Uruguay","dial_code":"+598","code":"UY"},{"name_en":"Uzbekistan","name_es":"Uzbekistán","dial_code":"+998","code":"UZ"},{"name_en":"Vanuatu","name_es":"Vanuatu","dial_code":"+678","code":"VU"},{"name_en":"Venezuela, Bolivarian Republic of","name_es":"Venezuela","dial_code":"+58","code":"VE"},{"name_en":"Vietnam","name_es":"Vietnam","dial_code":"+84","code":"VN"},{"name_en":"Virgin Islands, British","name_es":"Islas Vírgenes Británicas","dial_code":"+1284","code":"VG"},{"name_en":"Virgin Islands, U.S.","name_es":"Islas Vírgenes de los Estados Unidos","dial_code":"+1340","code":"VI"},{"name_en":"Wallis and Futuna","name_es":"Wallis y Futuna","dial_code":"+681","code":"WF"},{"name_en":"Yemen","name_es":"Yemen","dial_code":"+967","code":"YE"},{"name_en":"Zambia","name_es":"Zambia","dial_code":"+260","code":"ZM"},{"name_en":"Zimbabwe","name_es":"Zimbabue","dial_code":"+263","code":"ZW"},{"name_en":"Åland Islands","name_es":"Åland","dial_code":"+358","code":"AX"}]');
;// CONCATENATED MODULE: ./src/helpers/countries.js

var codes = [];
function countryCodes() {
    if (codes.length === 0) {
        codes = countries_namespaceObject.map(function(param) {
            var code = param.code;
            return code;
        });
    }
    return codes;
}
var options = [];
function countriesOptions() {
    if (options.length === 0) {
        options = countries_namespaceObject.map(function(param) {
            var code = param.code, name_es = param.name_es;
            return {
                value: code,
                display: name_es
            };
        });
    }
    return options;
}


/***/ }),

/***/ 75701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TrainersFormation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/components/SubHeading/index.js + 3 modules
var SubHeading = __webpack_require__(77276);
// EXTERNAL MODULE: ./src/components/Lead/index.js + 1 modules
var Lead = __webpack_require__(59679);
// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./src/components/Text/index.js + 1 modules
var Text = __webpack_require__(37346);
// EXTERNAL MODULE: ./src/components/Check/index.js + 1 modules
var Check = __webpack_require__(29468);
// EXTERNAL MODULE: ./src/components/Image/RemoteImage.js
var RemoteImage = __webpack_require__(49187);
// EXTERNAL MODULE: ./src/components/ScrollSpy/index.js + 2 modules
var ScrollSpy = __webpack_require__(82639);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/domain/Trainer/TrainerTestimonial.js


var defaultProps = {};
var propTypes = {
    testimonial: prop_types_default().shape({
        testimonial: (prop_types_default()).string.isRequired,
        trainer: (prop_types_default()).string.isRequired,
        trainerProfile: (prop_types_default()).string.isRequired,
        trainerPicture: (prop_types_default()).string.isRequired,
        position: (prop_types_default()).string,
        company: (prop_types_default()).string,
        companyUrl: (prop_types_default()).string
    }).isRequired
};
function TrainerTestimonial(param) {
    var t = param.testimonial;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: "relative shadow-lg lg:shadow-2xl rounded-xl flex-none grid grid-cols-1 lg:grid-cols-12 overflow-hidden bg-white z-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-1 lg:col-span-4 px-6 pt-6 md:p-10 flex flex-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full rounded-t-xl lg:rounded-xl overflow-hidden relative z-20 lg:h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: t.trainerPicture,
                        alt: t.trainer,
                        className: "rounded-t-xl lg:rounded-xl bg-green-100 w-full h-auto block lg:h-full object-cover",
                        loading: "lazy"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-1 lg:col-span-8 px-6 pb-6 md:pl-0 md:p-10 lg:pb-20 space-y-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                        className: "text-gray-900 font-medium leading-relaxed lg:leading-8 text-lg lg:text-xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "45",
                                height: "36",
                                className: "mb-5 fill-current text-green-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M13.415.001C6.07 5.185.887 13.681.887 23.041c0 7.632 4.608 12.096 9.936 12.096 5.04 0 8.784-4.032 8.784-8.784 0-4.752-3.312-8.208-7.632-8.208-.864 0-2.016.144-2.304.288.72-4.896 5.328-10.656 9.936-13.536L13.415.001zm24.768 0c-7.2 5.184-12.384 13.68-12.384 23.04 0 7.632 4.608 12.096 9.936 12.096 4.896 0 8.784-4.032 8.784-8.784 0-4.752-3.456-8.208-7.776-8.208-.864 0-1.872.144-2.16.288.72-4.896 5.184-10.656 9.792-13.536L38.183.001z"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t.testimonial
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                        className: "text-lg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-auto font-medium",
                            children: [
                                t.trainer,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-green-500 font-normal text-base",
                                    children: "".concat(t.position, " ").concat(t.company)
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
TrainerTestimonial.defaultProps = defaultProps;
TrainerTestimonial.propTypes = propTypes;

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Image/index.js + 7 modules
var Image = __webpack_require__(31233);
// EXTERNAL MODULE: ./src/components/Tooltip/index.js + 1 modules
var Tooltip = __webpack_require__(95888);
;// CONCATENATED MODULE: ./src/domain/CoachTraining/CoachTrainingAnimation.js






function renderTrainerTooltip(trainerCountry) {
    return function(tooltip) {
        var addDefaultClassName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, attrs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            tabIndex: "-1"
        }, attrs), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white rounded-full shadow-xl px-6 py-2 leading-normal transition ease-in-out duration-300 transform flex flex-col ring-1 ring-black ring-opacity-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-gray-900 text-sm font-medium leading-4",
                        children: tooltip
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-xs text-gray-700 leading-4",
                        children: trainerCountry
                    })
                ]
            })
        }));
    };
}
function CoachTrainingTrainerPicture(param) {
    var picture = param.picture, trainerName = param.trainerName, country = param.country, stylePosition = param.stylePosition, animation = param.animation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
        tooltip: trainerName,
        renderTooltip: renderTrainerTooltip(country),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: (0,clsx_m/* default */.Z)("cursor-pointer w-14 h-14 bg-white absolute z-20 rounded-full shadow-lg focus:outline-none transform origin-center", animation),
            style: stylePosition,
            type: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "entrenadores/".concat(picture),
                alt: trainerName,
                className: "w-full h-full rounded-full transform hover:scale-125 transition ease-linear",
                width: 180,
                height: 180
            })
        })
    });
}
function CoachTrainingAnimation() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative py-32 lg:absolute z-20 inset-0 grid grid-cols-1 lg:grid-cols-12 lg:items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:col-span-6 lg:col-start-8 flex items-center justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "rounded-full",
                    style: {
                        width: "210px",
                        height: "210px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "formacion/official-scrum-trainer-badge.png",
                        alt: "Official Scrum Trainer Certification",
                        className: "rounded-full w-full h-full shadow-outside-lg",
                        width: 300,
                        height: 300
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-96 h-96 absolute rounded-full opacity-10 z-0",
                    style: {
                        width: "350px",
                        height: "350px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full h-full border border-gray-900 rounded-full absolute shadow-outside-lg",
                        style: {
                            width: "350px",
                            height: "350px"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-96 h-96 absolute rounded-full z-20 animate-spin-slow",
                    style: {
                        width: "500px",
                        height: "500px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "carlos-paulino.png",
                            trainerName: "Carlos Paulino",
                            country: "Rep\xfablica Dominicana",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                left: "210px",
                                top: "-26px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "pedro-nogales.webp",
                            trainerName: "Pedro Nogales",
                            country: "Estados Unidos",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                left: "340px",
                                bottom: "5px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "linnet-acosta.webp",
                            trainerName: "Linnet Acosta",
                            country: "Canad\xe1",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                left: "140px",
                                bottom: "-90px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "federico-vargas.jpg",
                            trainerName: "Federico Vargas",
                            country: "Costa Rica",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                left: "40px",
                                top: "50px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "jimena-canales.png",
                            trainerName: "Jimena Canales",
                            country: "Per\xfa",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                right: "40px",
                                top: "50px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "javier-martin-agar.jpg",
                            trainerName: "Javier Mart\xedn Agar",
                            country: "Espa\xf1a",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                left: "210px",
                                bottom: "50px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "sandy-rodriguez.jpg",
                            trainerName: "Sandy Rodr\xedguez",
                            country: "M\xe9xico",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                left: "20px",
                                bottom: "75px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "adonis-rosales.png",
                            trainerName: "Adonis Rosales",
                            country: "Canad\xe1",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                right: "25px",
                                bottom: "75px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "Antonio_perfil.jpg",
                            trainerName: "Antonio Betancourt",
                            country: "Chile",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                left: "50px",
                                top: "210px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "erick-masgo.webp",
                            trainerName: "Erick Masgo",
                            country: "Per\xfa",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                left: "-100px",
                                top: "210px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "annabel-chelton.jpg",
                            trainerName: "Annabell Schelton",
                            country: "Chile",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                right: "50px",
                                top: "200px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingTrainerPicture, {
                            picture: "lucho-salazar.jpg",
                            trainerName: "Lucho Salazar",
                            country: "Colombia",
                            animation: "animate-spin-backwords-slow",
                            stylePosition: {
                                right: "-100px",
                                top: "220px"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-96 h-96 border border-gray-800 opacity-20 absolute rounded-full animate-spin-slow z-0 shadow-outside-lg",
                    style: {
                        width: "500px",
                        height: "500px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-96 h-96 border border-gray-500 opacity-20 absolute rounded-full animate-spin-slow shadow-outside-lg z-0",
                    style: {
                        width: "650px",
                        height: "650px"
                    }
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/domain/countries.js + 1 modules
var countries = __webpack_require__(74907);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/helpers/countries.js + 1 modules
var helpers_countries = __webpack_require__(20890);
;// CONCATENATED MODULE: ./src/domain/Forms/trainerApplyFormValidationSchema.js


/* harmony default export */ var trainerApplyFormValidationSchema = (es/* object */.Ry({
    firstname: es/* string */.Z_().required("Debe escribir su nombre").matches(/^[a-zA-Z0-9À-ú ]+$/i, "Solo se permiten valores alfanum\xe9ricos"),
    lastname: es/* string */.Z_().required("Debe escribir sus apellidos").matches(/^[a-zA-Z0-9À-ú ]+$/i, "Solo se permiten valores alfanum\xe9ricos"),
    email: es/* string */.Z_().required("Debe escribir su correo electr\xf3nico").email("Debe escribir un correo electr\xf3nico v\xe1lido"),
    country: es/* string */.Z_().required("Debe seleccionar un pa\xeds").oneOf((0,helpers_countries/* countryCodes */.n)(), "Solo se permite un c\xf3digo de dos letras v\xe1lido"),
    phone: es/* string */.Z_().required("Este campo es requerido").matches(/^(?=.*[0-9])[+()0-9 ]+$/i, "Solo se permiten n\xfameros de tel\xe9fonos v\xe1lidos")
}));

;// CONCATENATED MODULE: ./src/domain/Forms/CoachesTrainingRequestForm.js








var initialApplyFormData = {
    firstname: "",
    lastname: "",
    email: "",
    country: "",
    phone: ""
};
function CoachesTrainingRequestForm() {
    var onApplyFormSubmit = (0,react.useCallback)(function(values, param) {
        var setSubmitting = param.setSubmitting;
        setSubmitting(true);
        router.push({
            pathname: "/formacion-de-entrenadores-scrum/aplicar",
            query: values
        });
    }, []);
    var router = (0,next_router.useRouter)();
    var form = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialApplyFormData,
        validationSchema: trainerApplyFormValidationSchema,
        validateOnMount: true,
        onSubmit: onApplyFormSubmit
    });
    var _obj, _obj1, _obj2, _obj3, _obj4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: form.handleSubmit,
        className: "bg-gray-800 text-white rounded-lg w-full p-6 lg:p-8 flex flex-col space-y-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 space-y-4 md:space-y-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "w-full grid grid-cols-1 md:grid-cols-12 items-center gap-2",
                            htmlFor: "firstname",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-white font-semibold md:col-span-6",
                                    children: "Nombres"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (_obj = {
                                    className: (0,clsx_m/* default */.Z)("md:col-span-6 px-3 focus:outline-none bg-gray-700 border border-transparent rounded-md py-1 focus:border-transparent focus:ring-2 focus:ring-gray-500 focus:bg-gray-600 focus:ring-offset-2 focus:ring-offset-gray-800 font-medium placeholder-gray-500", form.isSubmitting === true && "opacity-50"),
                                    type: "text",
                                    id: "firstname",
                                    name: "firstname"
                                }, (0,_define_property/* default */.Z)(_obj, "type", "firstname"), (0,_define_property/* default */.Z)(_obj, "onChange", form.handleChange), (0,_define_property/* default */.Z)(_obj, "value", form.values.firstname), (0,_define_property/* default */.Z)(_obj, "disabled", form.isSubmitting), (0,_define_property/* default */.Z)(_obj, "required", true), _obj))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "items-center w-full grid grid-cols-1 md:grid-cols-12 gap-2",
                            htmlFor: "lastname",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-white font-semibold md:col-span-6",
                                    children: "Apellidos"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (_obj1 = {
                                    className: (0,clsx_m/* default */.Z)("md:col-span-6 px-3 focus:outline-none bg-gray-700 border border-transparent rounded-md py-1 focus:border-transparent focus:ring-2 focus:ring-gray-500 focus:bg-gray-600 focus:ring-offset-2 focus:ring-offset-gray-800 font-medium placeholder-gray-500", form.isSubmitting === true && "opacity-50"),
                                    type: "text",
                                    id: "lastname",
                                    name: "lastname"
                                }, (0,_define_property/* default */.Z)(_obj1, "type", "lastname"), (0,_define_property/* default */.Z)(_obj1, "onChange", form.handleChange), (0,_define_property/* default */.Z)(_obj1, "value", form.values.lastname), (0,_define_property/* default */.Z)(_obj1, "disabled", form.isSubmitting), (0,_define_property/* default */.Z)(_obj1, "required", true), _obj1))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "items-center w-full grid grid-cols-1 md:grid-cols-12 gap-2",
                            htmlFor: "email",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-white font-semibold md:col-span-6",
                                    children: "Correo electr\xf3nico"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (_obj2 = {
                                    className: (0,clsx_m/* default */.Z)("md:col-span-6 px-3 focus:outline-none bg-gray-700 border border-transparent rounded-md py-1 focus:border-transparent focus:ring-2 focus:ring-gray-500 focus:bg-gray-600 focus:ring-offset-2 focus:ring-offset-gray-800 font-medium placeholder-gray-500", form.isSubmitting === true && "opacity-50"),
                                    type: "text",
                                    id: "email",
                                    name: "email"
                                }, (0,_define_property/* default */.Z)(_obj2, "type", "email"), (0,_define_property/* default */.Z)(_obj2, "onChange", form.handleChange), (0,_define_property/* default */.Z)(_obj2, "value", form.values.email), (0,_define_property/* default */.Z)(_obj2, "disabled", form.isSubmitting), (0,_define_property/* default */.Z)(_obj2, "required", true), _obj2))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "items-center w-full grid grid-cols-1 md:grid-cols-12 gap-2",
                            htmlFor: "country",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-white font-semibold md:col-span-6",
                                    children: "Pa\xeds"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("select", (_obj3 = {
                                    className: (0,clsx_m/* default */.Z)("md:col-span-6 px-3 focus:outline-none bg-gray-700 border border-transparent rounded-md py-1 focus:border-transparent focus:ring-2 focus:ring-gray-500 focus:bg-gray-600 focus:ring-offset-2 focus:ring-offset-gray-800 font-medium placeholder-gray-500", form.isSubmitting === true && "opacity-50"),
                                    type: "text",
                                    placeholder: "Espa\xf1a",
                                    id: "country",
                                    name: "country"
                                }, (0,_define_property/* default */.Z)(_obj3, "type", "country"), (0,_define_property/* default */.Z)(_obj3, "onChange", form.handleChange), (0,_define_property/* default */.Z)(_obj3, "value", form.values.country), (0,_define_property/* default */.Z)(_obj3, "disabled", form.isSubmitting), (0,_define_property/* default */.Z)(_obj3, "required", true), (0,_define_property/* default */.Z)(_obj3, "children", (0,countries/* countriesOptions */._)().map(function(param) {
                                    var value = param.value, display = param.display;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: value,
                                        children: display
                                    }, value);
                                })), _obj3))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: "items-center w-full grid grid-cols-1 md:grid-cols-12 gap-2",
                            htmlFor: "phone",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-white font-semibold md:col-span-6 flex-1 flex items-center",
                                    children: "Tel\xe9fono"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (_obj4 = {
                                    className: (0,clsx_m/* default */.Z)("md:col-span-6 px-3 focus:outline-none bg-gray-700 border border-transparent rounded-md py-1 focus:border-transparent focus:ring-2 focus:ring-gray-500 focus:bg-gray-600 focus:ring-offset-2 focus:ring-offset-gray-800 font-medium placeholder-gray-500", form.isSubmitting === true && "opacity-50"),
                                    type: "text",
                                    id: "phone",
                                    name: "phone"
                                }, (0,_define_property/* default */.Z)(_obj4, "type", "phone"), (0,_define_property/* default */.Z)(_obj4, "onChange", form.handleChange), (0,_define_property/* default */.Z)(_obj4, "value", form.values.phone), (0,_define_property/* default */.Z)(_obj4, "disabled", form.isSubmitting), (0,_define_property/* default */.Z)(_obj4, "required", true), _obj4))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center md:justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (0,clsx_m/* default */.Z)("rounded-full bg-green-600 inline-flex px-5 py-2 leading-5 font-semibold text-gray-900 transition ease-in-out duration-300", (form.isValid === false || form.isSubmitting === true) && "opacity-50 pointer-events-none", form.isValid === true && form.isSubmitting === false && "hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-gray-900"),
                    disabled: form.isValid === false || form.isSubmitting === true,
                    type: "submit",
                    children: form.isSubmitting ? "Iniciando proceso" : "Comenzar proceso"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/domain/Trainer/testimonials.js
var federicoVargas = {
    testimonial: "Mi mayor satisfacci\xf3n como entrenador de la Asociaci\xf3n Iberoamericana de Scrum es poder ayudar a personas de toda la regi\xf3n a trav\xe9s de los entrenamientos que imparto. Comparto el prop\xf3sito de AIBES de entregar entrenamientos de calidad, con una formaci\xf3n responsable, ense\xf1ando desde mi experiencia e influyendo positivamente en el desempe\xf1o profesional de las personas con las que interact\xfao. Creo en la posibilidad de cambiar el Mundo por medio de la formaci\xf3n de mejores individuos y como entrenador de AIBES puedo servir a este prop\xf3sito.",
    trainer: "Federico Vargas",
    trainerProfile: "/entrenadores/federico-vargas/",
    trainerPicture: "/images/entrenadores/federico-vargas.jpg",
    position: "CEO de",
    company: "Grupo Empresarial 360",
    companyUrl: "/socios/grupo-empresarial-360/"
};
var erickMasgo = {
    testimonial: "El \xe9xito de las formaciones a nuestro cargo no s\xf3lo se basa en la certificaci\xf3n, sino en el compromiso de los que formamos parte de la AIBES para entregar contenido de valor y con la responsabilidad que significa la aplicaci\xf3n de estos conocimientos en las diferentes organizaciones. AIBES se consolida como una certificadora responsable en la formaci\xf3n de profesionales hispanohablantes, para m\xed es un gusto formar parte de esta prestigiosa organizaci\xf3n y colaborar en sus procesos formativos en la entrega de contenidos de valor desde una visi\xf3n pr\xe1ctica.",
    trainer: "Erick Masgo",
    trainerProfile: "/entrenadores/erick-masgo/",
    trainerPicture: "/images/entrenadores/erick-masgo.jpg",
    position: "Gerente General en",
    company: "F&M Consulting",
    companyUrl: "/socios/fm-consulting/"
};

;// CONCATENATED MODULE: ./src/pages/formacion-de-entrenadores-scrum/index.js














function TrainersFormation() {
    var competenciesRef = (0,react.useRef)(null);
    var evaluationRef = (0,react.useRef)(null);
    var applyRef = (0,react.useRef)(null);
    var sectionRefs = [
        competenciesRef,
        evaluationRef,
        applyRef
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSpy/* default */.Z, {
        offset: -100,
        sectionRefs: sectionRefs,
        children: function(param) {
            var currentElementIndexInViewport = param.currentElementIndexInViewport;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-20 overflow-hidden bg-gradient-to-tr from-violet-300 via-green-100 to-violet-200 lg:py-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                                className: "pt-10 pb-20 lg:py-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 lg:grid-cols-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative z-50 flex flex-col space-y-8 py-10 pr-10 lg:col-span-6 lg:py-20 lg:pr-20",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading/* default */.Z, {
                                                        color: "text-violet-900",
                                                        heading: "S\xfamate a nuestro equipo"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "mb-4 text-5xl font-bold tracking-tight lg:text-6xl lg:font-extrabold",
                                                        children: "F\xf3rmate como entrenador"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                                                        children: "Los Official Scrum Trainer (OSTC) son profesionales con licencia para ofrecer entrenamientos y certificaciones de la AIBES."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "inline-flex rounded-full bg-violet-800 px-5 py-3 text-lg font-semibold leading-none text-white hover:bg-violet-900 focus:bg-violet-900 focus:ring-4 focus:ring-violet-900 focus:ring-opacity-20",
                                                    href: "#aplicar",
                                                    children: "Aplica hoy mismo"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachTrainingAnimation, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative top-0 z-30 hidden bg-white shadow-sm md:sticky md:block",
                        style: {
                            backdropFilter: "blur(20px) saturate(120%)",
                            backgroundColor: "rgba(255, 255, 255, 0.5)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center space-x-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center space-x-4 lg:-mb-px lg:space-x-10 xl:space-x-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSpy/* ScrollSpyItem */.H, {
                                            anchor: "competencias",
                                            label: "Competencias",
                                            targetClassName: "flex items-center border-b-2 border-transparent py-4 lg:py-6 leading-6 font-medium",
                                            className: currentElementIndexInViewport === 0 ? "border-green-500 text-green-500" : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSpy/* ScrollSpyItem */.H, {
                                            anchor: "evaluacion",
                                            label: "Evaluaci\xf3n y desempe\xf1o",
                                            targetClassName: "flex items-center border-b-2 border-transparent py-4 lg:py-6 leading-6 font-medium",
                                            className: currentElementIndexInViewport === 1 ? "border-green-500 text-green-500" : ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollSpy/* ScrollSpyItem */.H, {
                                            anchor: "aplicar",
                                            label: "Aplicar",
                                            targetClassName: "flex items-center border-b-2 border-transparent py-4 lg:py-6 leading-6 font-medium",
                                            className: currentElementIndexInViewport === 2 ? "border-green-500 text-green-500" : ""
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "competencias",
                        className: "relative z-10 py-10 lg:py-20",
                        ref: competenciesRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
                                className: "relative z-10 space-y-10 py-10 lg:space-y-16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center space-y-1 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    className: "h-20 w-20",
                                                    width: "48",
                                                    height: "48",
                                                    viewBox: "0 0 48 48",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            className: "fill-current text-violet-500",
                                                            x: "19",
                                                            y: "37",
                                                            width: "10",
                                                            height: "5"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            className: "fill-current text-violet-200",
                                                            d: "M31,30c-1.917,1.186-2,3.742-2,6v1H19V36c0-2.258-.118-4.874-2-6a13.355,13.355,0,0,1-6-11.308A12.849,12.849,0,0,1,24,6,12.849,12.849,0,0,1,37,18.692,13.355,13.355,0,0,1,31,30Z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            className: "fill-current text-violet-400",
                                                            d: "M26,27.633V37H22V27.633A5.982,5.982,0,0,1,18,22h3.6a2.4,2.4,0,0,0,4.8,0H30A5.982,5.982,0,0,1,26,27.633Z"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading/* default */.Z, {
                                                        color: "text-violet-700",
                                                        heading: "Competencias"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "mb-4 text-3xl font-bold tracking-tight lg:text-4xl",
                                                        children: "Nuestros entrenadores"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "rounded-2xl bg-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "rounded-2xl shadow-2xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "grid grid-cols-1 space-y-10 p-10 lg:grid-cols-12 lg:gap-8 lg:space-y-0 lg:divide-x lg:p-14",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col space-y-4 lg:col-span-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                                size: "w-8 h-8",
                                                                className: "text-green-400"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                children: "Tienen vasta experiencia y conocimientos demostrados. Son reconocidos referentes en la regi\xf3n por su contribuci\xf3n y desarrollo en procesos de transformaci\xf3n organizacional."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col space-y-4 lg:col-span-4 lg:pl-8",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                                size: "w-8 h-8",
                                                                className: "text-green-400"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                children: "Tienen experiencia internacional a trav\xe9s de programas de entrenamientos, eventos, charlas y congresos a nivel internacional que permiten la socializaci\xf3n del conocimiento."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col space-y-4 lg:col-span-4 lg:pl-8",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                                size: "w-8 h-8",
                                                                className: "text-green-400"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                children: "Contribuyen con las empresas para la adopci\xf3n de la cultura \xe1gil a trav\xe9s de m\xe9todos profesionales, innovadores y con resultados demostrados."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "rounded-2xl bg-gradient-to-t from-violet-900 to-violet-800 p-4 font-medium text-violet-200 shadow-lg lg:px-20 lg:py-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "p-4 text-center leading-6 lg:p-0",
                                            children: "Todos los OSTC utilizan el mismo material base estandarizado por AIBES, pero son libres de hacer adaptaciones para diferentes entornos y pa\xedses, en todos los casos, aportan su propio estilo y experiencia a sus entrenamientos. El uso de materiales preparados de forma central por AIBES, para el cual se toma en cuenta la experiencia y el conocimiento de todos los profesionales que la componen, garantiza que todos los estudiantes de sus entrenamientos adquieren el mismo nivel de preparaci\xf3n, independientemente del Entrenador, el entrenamiento o el lugar donde se imparta."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerTestimonial, {
                                        testimonial: federicoVargas
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 z-0 -mt-20 h-full w-full -skew-y-6 transform bg-white bg-gradient-to-b from-white to-green-100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "evaluacion",
                        className: "relative py-10 lg:pt-20 lg:pb-32",
                        ref: evaluationRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
                                className: "relative z-10 space-y-10 pt-10 lg:space-y-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center space-y-1 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    className: "h-20 w-20",
                                                    width: "48",
                                                    height: "48",
                                                    viewBox: "0 0 48 48",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                            className: "fill-current text-violet-500",
                                                            x: "19",
                                                            y: "37",
                                                            width: "10",
                                                            height: "5"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            className: "fill-current text-violet-200",
                                                            d: "M31,30c-1.917,1.186-2,3.742-2,6v1H19V36c0-2.258-.118-4.874-2-6a13.355,13.355,0,0,1-6-11.308A12.849,12.849,0,0,1,24,6,12.849,12.849,0,0,1,37,18.692,13.355,13.355,0,0,1,31,30Z"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            className: "fill-current text-violet-400",
                                                            d: "M26,27.633V37H22V27.633A5.982,5.982,0,0,1,18,22h3.6a2.4,2.4,0,0,0,4.8,0H30A5.982,5.982,0,0,1,26,27.633Z"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading/* default */.Z, {
                                                        color: "text-violet-700",
                                                        heading: "Evaluaci\xf3n y desempe\xf1o"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "mb-4 text-3xl font-bold tracking-tight lg:text-4xl",
                                                        children: "Calidad de las capacitaciones"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-20 lg:grid-cols-12 lg:items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative space-y-4 lg:col-span-6 lg:py-20",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-col space-y-4 md:flex-row md:items-start md:space-y-0 md:space-x-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-1 flex-col space-y-4 lg:space-y-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "text-xl font-bold tracking-tight lg:w-3/4 lg:text-3xl xl:text-4xl",
                                                                children: "Evaluaci\xf3n y mejoramiento continuo"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-lg leading-8 text-gray-600 lg:pr-20",
                                                                children: "Nuestros entrenadores son evaluados y mejoran su desempe\xf1o a trav\xe9s de la retroalimentaci\xf3n que reciben de sus estudiantes."
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex lg:col-span-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "aspect-w-16 aspect-h-10 relative z-50 overflow-hidden rounded shadow-lg lg:rounded-lg lg:shadow-xl xl:rounded-xl",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute inset-0",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                                                                    src: "v1616985273/formacion/entrenadores-feedback_w2d165.jpg",
                                                                    alt: "Retroalimentaci\xf3n de entrenadores",
                                                                    layout: "fill",
                                                                    objectFit: "cover"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute top-0 left-0 -mt-4 -ml-4 h-14 w-2/4 rounded bg-violet-500 lg:rounded-lg"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute bottom-0 right-0 -mr-4 mb-10 h-16 w-2/5 rounded bg-violet-500 lg:rounded-lg"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute bottom-0 left-0 z-50 -ml-10 mb-10 h-16 w-44 rounded border-2 border-violet-500 lg:rounded-lg"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-20 lg:grid-cols-12 lg:items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative space-y-4 lg:order-2 lg:col-span-6 lg:py-20",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-col space-y-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-1 flex-col space-y-4 lg:space-y-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "text-xl font-bold tracking-tight lg:w-2/4 lg:text-3xl xl:text-4xl",
                                                                children: "Cultura de retroalimentaci\xf3n"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-lg leading-8 text-gray-600 lg:pr-20",
                                                                children: "Anualmente se re\xfanen para compartir sus experiencias y mejorar en conjunto los materiales de cada curso impartido por ellos, as\xed como los materiales que son utilizados en cada entrenamiento."
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex lg:order-1 lg:col-span-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex w-full rounded-lg bg-gray-200 lg:rounded-xl xl:rounded-2xl",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "relative w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "aspect-w-16 aspect-h-10 relative z-50 overflow-hidden rounded shadow-lg lg:rounded-lg lg:shadow-xl xl:rounded-xl",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "absolute inset-0",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                                                                        src: "v1616985273/formacion/formacion-entrenadores-scrum_zrr6it.jpg",
                                                                        alt: "Encuentro anual de entrenadores",
                                                                        layout: "fill",
                                                                        objectFit: "cover"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute top-0 left-0 -mt-6 -ml-20 h-14 w-2/4 rounded bg-violet-500 lg:rounded-lg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 right-0 -mr-4 mb-10 h-16 w-2/5 rounded bg-violet-500 lg:rounded-lg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 left-0 z-50 -ml-4 mb-10 h-16 w-44 rounded border-2 border-violet-500 lg:rounded-lg"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-20 lg:grid-cols-12 lg:items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative space-y-4 lg:col-span-6 lg:py-20",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex flex-col space-y-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-1 flex-col space-y-4 lg:space-y-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "text-xl font-bold tracking-tight lg:text-3xl xl:text-4xl",
                                                                children: "Calidad en la ense\xf1anza"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-lg leading-8 text-gray-600 lg:pr-20",
                                                                children: "Los materiales de los cursos impartidos por nuestros entrenadores son los de m\xe1s alta calidad, consistencia y profesionalismo. El prestigio y el reconocimiento de sus entrenadores y certificaciones dan fe de ello."
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex lg:col-span-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex w-full rounded-lg bg-gray-200 lg:rounded-xl xl:rounded-2xl",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "relative w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "aspect-w-16 aspect-h-10 relative z-50 overflow-hidden rounded shadow-lg lg:rounded-lg lg:shadow-xl xl:rounded-xl",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "absolute inset-0",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteImage/* default */.Z, {
                                                                        src: "v1616985273/formacion/material-de-entrenadores_lbnyhz.jpg",
                                                                        alt: "Retroalimentaci\xf3n de entrenadores",
                                                                        layout: "fill",
                                                                        objectFit: "cover"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute top-0 left-0 -mt-6 -ml-10 h-14 w-2/4 rounded bg-violet-500 lg:rounded-lg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 right-0 -mr-4 mb-10 h-16 w-2/5 rounded bg-violet-500 lg:rounded-lg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute bottom-0 left-0 z-50 -ml-4 mb-10 h-16 w-44 rounded border-2 border-violet-500 lg:rounded-lg"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-0 z-0 -mt-20 h-full w-full -skew-y-6 transform bg-white"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                        className: "lg:-mt-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrainerTestimonial, {
                            testimonial: erickMasgo
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "aplicar",
                        className: "relative",
                        ref: applyRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-20 lg:pt-32",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                                    className: "relative z-10 space-y-10 lg:space-y-20 lg:py-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-1 gap-10 lg:grid-cols-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "space-y-4 text-white lg:col-span-6 lg:space-y-8 lg:pt-5 lg:pr-10",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeading/* default */.Z, {
                                                                color: "text-violet-700",
                                                                heading: "Aplicar"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                className: "text-3xl font-semibold tracking-tight lg:text-4xl",
                                                                children: "Inicia tu camino como Entrenador"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-lg text-gray-400",
                                                        children: "Aplica hoy mismo y comienza el proceso de formaci\xf3n como entrenador de AIBES."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "space-y-6 md:space-y-4 lg:col-span-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CoachesTrainingRequestForm, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "px-4 text-xs leading-normal text-gray-600",
                                                        children: [
                                                            "Cualquier informaci\xf3n que usted nos pueda proporcionar permanece privada y no es compartida con ning\xfan fin comercial con terceros. Para mayor informaci\xf3n revise nuestras\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                className: "font-medium text-gray-500",
                                                                href: "/legal/privacidad",
                                                                children: "Pol\xedticas de privacidad"
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-20 bg-gray-900"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute top-0 z-0 grid h-full w-full -skew-y-6 transform grid-cols-12 grid-rows-6 bg-gray-900",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-3 col-start-10 -mt-10 h-10 bg-violet-500"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-1 row-start-1 h-10 bg-gray-800"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-1 col-start-2 row-start-1 -mt-10 h-10 border"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
};
TrainersFormation.layoutProps = {
    stickyHeader: false
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,2175,4231,5531,9774,2888,179], function() { return __webpack_exec__(75018); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);